import React from 'react';
import cn from 'classnames';
import Svg from '../../../../../../common/components/Svg'
import SvgIcon from "../../../../../../common/SvgIcon";

const OptionsListItemImage = ({ color, image, icon, sprite, value, title, selected, disabled, onChange }) => (
  <div className={cn('onboarding-reaction  -select-behaviour', {
    '-selected': selected,
    '-disabled': disabled
  })} onClick={disabled ? undefined : () => onChange(value)}>
    {color ? (
      <div style={{ backgroundColor: color }} className="onboarding-reaction_color" />
    ) : (
      <div className={cn("onboarding-reaction_picture ", { ' icon': icon && icon })}>
        {icon ? (
          <SvgIcon icon={icon} sprite={sprite} className="onboarding-reaction_icon" />
        ) : (
          <img src={image} className="onboarding-reaction_image" alt="" />
        )}
      </div>
    )}
    {title && <div className={cn("onboarding-reaction_title ", { ' icon': icon && icon })}>{title}</div>}
  </div>
);

export default OptionsListItemImage;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/OptionsList/OptionsListItemImage.js